/* eslint-disable @typescript-eslint/naming-convention */
import type { BonusGrid, Meta } from '@ps/web-martech-cms-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { CMSBonus, CMSPageSection } from '@swf/cms';
import { select } from '@swf/core/store';

import styles from './CMSBonusGrid.scss';

const MessageDismissTimeMs = 3000;
let cancelSetTimeout: NodeJS.Timeout;

const CMSBonusGrid: React.FC<BonusGrid> = ({
  heading,
  intro,
  number_of_columns = 2,
  items: references
}) => {
  const [selectedCode, setSelectedCode] = useState<string>('');
  const data = useSelector(select.cms.getContent);

  const items = references
    .map((item) => data[item.uid] as Meta)
    .map(({ bonus, visibility_rules }) => ({ bonus, visibility_rules }));

  const onClick = ({ code }: Meta['bonus']) => {
    if (code === selectedCode) {
      return;
    }

    clearTimeout(cancelSetTimeout);
    setSelectedCode(code || '');
    navigator.clipboard.writeText(code || '');
    cancelSetTimeout = setTimeout(() => {
      setSelectedCode('');
    }, MessageDismissTimeMs);
  };

  return (
    <CMSPageSection heading={heading} intro={intro} grid columns={number_of_columns}>
      {!!items.length &&
        items.map((item, index) => (
          <CMSBonus
            key={index}
            {...item}
            onClick={() => {
              onClick(item.bonus);
            }}
          />
        ))}
      {selectedCode.length > 0 && <div className={styles.banner}>Copied to clipboard</div>}
    </CMSPageSection>
  );
};

export default CMSBonusGrid;
